import { InvoiceExportTypeId } from '@previo/codebooks'

export class DefaultCountryStrategy {
  public allowedSoftware: InvoiceExportTypeId[] = []
}
